export default __webpack_public_path__ + "static/media/bookstore_background.6bdadf12.jpg";